// src/components/Footer.tsx
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faThreads, faTiktok } from '@fortawesome/free-brands-svg-icons';
import api from '../services/api';

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  return (
    <footer className="w-full bg-[#f5ebe0] text-[#060300] flex justify-center p-8 md:p-12">
      {/* Container for cards */}
      <div className="flex flex-col md:flex-row flex-nowrap gap-6 w-full max-w-6xl">
        
        {/* Subscribe */}
        <div className="flex-1 min-w-0 flex flex-col items-center md:items-start bg-gradient-to-br from-gray-100 to-gray-50 p-6 rounded-xl shadow-md">
          <h4 className="mb-3 font-semibold text-lg">SUBSCRIBE</h4>
          <p className="mb-4 text-sm text-gray-700">Get the latest updates and offers.</p>
          <form
            className="flex flex-col md:flex-row gap-2 w-full"
            onSubmit={async (e) => {
              e.preventDefault();
              if (!email) return setMsg({ type: 'error', text: 'Please enter your email' });
              setLoading(true);
              try {
                const res = await api.post('/subscribe', { email });
                setMsg({ type: 'success', text: res.data?.message || 'Subscribed' });
                setEmail('');
              } catch (err: any) {
                setMsg({ type: 'error', text: err?.response?.data?.message || 'Subscription failed' });
              } finally {
                setLoading(false);
                setTimeout(() => setMsg(null), 3000);
              }
            }}
          >
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 flex-1 min-w-0"
            />
            <button
              type="submit"
              disabled={loading}
              className="p-3 text-[#292929] font-bold rounded-lg bg-[#e8e0a3] hover:bg-[#d6cf91] transition-all shadow-sm hover:shadow-md w-full md:w-auto disabled:opacity-60"
            >
              {loading ? 'Saving...' : 'Subscribe'}
            </button>
          </form>
          {msg && <p className={`mt-2 text-sm ${msg.type === 'error' ? 'text-red-600' : 'text-green-600'}`}>{msg.text}</p>}
        </div>

        {/* Contact */}
        <div className="flex-1 min-w-0 flex flex-col items-center md:items-start bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl shadow-md">
          <h4 className="mb-3 font-semibold text-lg">CONNECT</h4>
          <ul className="space-y-2 text-sm text-gray-700">
            <li>Email: info@beautonde.com</li>
            <li>Phone: +256 701 017 562</li>
            <li>Location: Lweza opposite Shell</li>
          </ul>
        </div>

        {/* Follow Us */}
        <div className="flex-1 min-w-0 flex flex-col items-center md:items-start bg-gradient-to-br from-gray-100 to-gray-50 p-6 rounded-xl shadow-md">
          <h4 className="mb-3 font-semibold text-lg">FOLLOW US</h4>
          <ul className="flex justify-center md:justify-start gap-4 mb-4">
            <li>
              <a
                href="https://www.facebook.com/beautonde.impressions/"
                aria-label="Facebook"
                className="text-gray-800 hover:text-black text-2xl transition-transform transform hover:scale-110"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/beau_tonde/?hl=en"
                aria-label="Instagram"
                className="text-gray-800 hover:text-black text-2xl transition-transform transform hover:scale-110"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </li>
            <li>
              <a
                href="https://www.threads.com/@beau_tonde"
                aria-label="Threads"
                className="text-gray-800 hover:text-black text-2xl transition-transform transform hover:scale-110"
              >
                <FontAwesomeIcon icon={faThreads} />
              </a>
            </li>
            <li>
              <a
                href="https://www.tiktok.com/@beautonde"
                aria-label="TikTok"
                className="text-gray-800 hover:text-black text-2xl transition-transform transform hover:scale-110"
              >
                <FontAwesomeIcon icon={faTiktok} />
              </a>
            </li>
          </ul>
          <p className="mt-2 text-sm text-gray-600">© nzimbaTech 2025</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
